export enum AssetType {
	Property = 'Property',
	Vehicle = 'Vehicle',
}
